export function getdata() {
	let obj = {
		searchlist: [{
				prop: "tc.tcode",
				label: '分析代码',
				type: "select",
				selectval: []
			},
			{
				prop: "tc.refCode",
				label: '代码',
				type: "input",
			},
			// {
			// 	prop: "refCodeDesc",
			// 	label: '代码描述',
			// 	type: "input",
			// }, {
			// 	prop: "mappingType",
			// 	label: '映射类型',
			// 	type: "select",
			// 	selectval: [{
			// 		label: "不参与映射：(导入时为无)",
			// 		value: "1"
			// 	}, {
			// 		label: "分析代码对应到1级科目: (导入时为TP) ",
			// 		value: "2"
			// 	}, {
			// 		label: "分析代码对应到末级科目: (导入时为TL)",
			// 		value: "3"
			// 	}]
			// },
			{
				prop: "tc.refAccountCode",
				label: '本地科目',
				type: "input",
			},
			{
				prop: "ca.accountDesc",
				label: '本地科目描述',
				type: "input",
			},
		],
		searchdata: {
			"tc.tcode": '',
			"tc.refCode": "",
			"tc.refAccountCode": '',
			"ca.accountDesc": '',
		},
		headData: [{
				title: "分析代码",
				prop: "tcode",
				width: "120",
				custom: true,
				issort: true,
			},
			{
				title: "代码",
				prop: "refCode",
				width: "120",
				issort: true,
			},
			{
				title: "代码描述",
				prop: "refCodeDesc",
				width: "120",
				issort: true,
			},
			{
				title: "映射类型",
				prop: "mappingType",
				width: "120",
				custom: true,
				issort: true,
			},
			{
				title: "本地科目",
				prop: "refAccountCode",
				width: "120",
				issort: true,
			},
			{
				title: "本地科目描述",
				prop: "accountDesc",
				width: "130",
				issort: true,
			},
			{
				title: "操作",
				prop: "cz",
				width: "200",
				fixed: "right",
				custom: true
			},

		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
